import { RoutingInterface } from '~/core/services/navigation/interfaces/routing.interface';

export const organizerActivityPlanningRoutingConfig: RoutingInterface[] = [
  {
    routeName: 'organizer.activity-planning.steps-2',
  },
  {
    routeName: 'organizer.activity-planning.activity',
  },
  {
    routeName: 'organizer.activity-planning.my-planning-validation',
  },
];
